import {Box, Flex, Text} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import CohortWidget from './components/CohortWidget';
import SalesSectionCard from './components/SalesSectionCard';
import { COHORT_TYPE } from './constants/cohortsConfig';
import UaRoasPredictionChart from "./components/UaRoasPredictionChart";
import SelectInput from "../../../../../components/inputs/SelectInput";
import {useEffect, useMemo, useState} from "react";
import cloneDeep from "lodash.clonedeep";

const Roas = ({ cohortsData, marketingViewName }) => {
  return (
    <SalesSectionCard title={'ROAS (Cumulative)'}>
      {marketingViewName ? (
        <Text mt={4} fontSize="sm" color="gray.600">
          ROAS based on view {marketingViewName}; covenants use default marketing data
        </Text>
      ) : null}
      <Box mt={50}>
        <CohortWidget
          cohortsData={cohortsData}
          cohortConfigKey={COHORT_TYPE.ROAS}
        />
      </Box>
      <Box mt={50}>
          <UaRoasPredictionChart cohortsData={cohortsData} />
      </Box>
    </SalesSectionCard>
  );
};

Roas.propTypes = {
  cohortsData: PropTypes.object,
  marketingViewName: PropTypes.string,
};

export default Roas;
